exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-495e1e1a] {\n  font-size: 51px;\n  line-height: 72px;\n  margin-bottom: 20px;\n  font-weight: 700;\n  color: rgb(0, 0, 0);\n  letter-spacing: 1px;\n}\n@media only screen and (max-width: 575px) {\nh2[data-v-495e1e1a] {\n    font-size: 35px;\n    line-height: 45px;\n}\n}\n", ""]);

// exports
